import { CubeEditorData } from 'Cube/domain/cube.domain.types'

/**
 * Quick and easy way of detecting whether changing the deal type to amendment
 * will overwrite any existing phase/price config in the quote.
 */
export const hasPricingToOverwrite = (data: CubeEditorData): boolean =>
  data.common.phaseIds
    .map(phaseId => data.phases[phaseId])
    .some(
      phase =>
        phase.priceIds.length > 0 ||
        phase.discountIds.length > 0 ||
        phase.minimumIds.length > 0
    )
